'use strict';

var THEME_COOKIE_NAME = 'theme';
var THEME_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

module.exports = function () {
    var $toggle = $('.js-theme-toggle');

    if (!$toggle.length) {
        return;
    }

    $toggle.prop('checked', document.documentElement.getAttribute('data-bs-theme') === 'dark');

    $toggle.on('change', function () {
        var newTheme = this.checked ? 'dark' : 'light';

        document.documentElement.setAttribute('data-bs-theme', newTheme);
        document.cookie = THEME_COOKIE_NAME + '=' + newTheme + '; path=/; max-age=' + THEME_COOKIE_MAX_AGE;
    });
};
